module.exports = __webpack_public_path__ + "vue_assets/img/img_membership_sub_12.642de69d.png";